import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Btnone from '../basic/button/one';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllFeaturedCategories } from '../../../redux/slices/category';
import defultimage from '../../../assets/home/img.png';

const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL;

const settings = {
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const CarouselCard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isLoading: featuredLoading, error, featured } = useSelector((state) => state.category);
  const [allfeaturedData, setAllfeaturedData] = useState([]);

  useEffect(() => {
    dispatch(fetchAllFeaturedCategories());
  }, [dispatch]);

  useEffect(() => {
    if (featured?.length) {
      setAllfeaturedData(featured);
    }
  }, [featured]);

  const categoriDetailsRow = (id) => {
    navigate(`/categories/${id}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (featuredLoading) {
    return (
      <Slider {...settings} className='py-10'>
        {[...Array(3)].map((_, index) => (
          <div key={index} className="animate-pulse border border-blue-200 shadow rounded-md p-3">
            <div className="flex flex-col items-center justify-center rounded-lg p-3">
              <div className="w-[150px] h-[150px] bg-gray-300 mb-2 mx-auto rounded-lg"></div>
              <div className="h-4 w-24 bg-gray-300 rounded-full mb-2"></div>
              <div className="h-4 w-32 bg-gray-300 rounded-full"></div>
            </div>
          </div>
        ))}
      </Slider>
    );
  }

  if (error) {
    return (
      <div className="py-10 text-center text-red-600">
        <p>Something went wrong. Please try again later.</p>
      </div>
    );
  }

  // Don't show anything if data is empty
if (!allfeaturedData.length) {
  return <div className="pb-10"></div>; // or py-20 for more space
}

  return (
    <Slider {...settings} className='py-10'>
      {allfeaturedData.map((item, index) => (
        <div key={index} className="px-2 flex justify-center">
          <div
            className="w-[300px] h-[250px] bg-white rounded-lg overflow-hidden shadow relative cursor-pointer"
            onClick={() => categoriDetailsRow(item.id)}
          >
            <div className="w-full h-full overflow-hidden">
              <img
                src={item?.feature_image ? BASE_IMAGE_URL + item?.feature_image : defultimage}
                alt="category"
                className="zoom-image shadow rounded-lg overflow-hidden object-cover cursor-pointer h-full w-full"
              />
            </div>
            <div className='absolute card_gradient px-3 py-3'>
              <p className='text-white font-dm'>{item?.name}</p>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default CarouselCard;
